import { MEMBER_STATUS } from '../../../../constants/index.ts';
import { BlueButton } from '@share/components';
import { FormattedMessage } from 'react-intl';

const FilterableHeader = (props: any) => {
  const { filter, setFilter, setIsOpen } = props;
  return (
    <div className="row g-4 justify-content-between align-items-center">
      {/* Filter options */}
      <div className="col-lg-8">
        <ul className="nav nav-pills-shadow nav-responsive">
          <li className="nav-item">
            <a
              className={`nav-link mb-0 me-sm-2 ${
                filter === MEMBER_STATUS.ALL && MEMBER_STATUS.ACTIVE
              }`}
              onClick={() => setFilter(MEMBER_STATUS.ALL)}
            >
              <FormattedMessage id="all" />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link mb-0 me-sm-2 ${
                filter === MEMBER_STATUS.ACTIVE && MEMBER_STATUS.ACTIVE
              }`}
              onClick={() => setFilter(MEMBER_STATUS.ACTIVE)}
            >
              <FormattedMessage id="active" />
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link mb-0 ${
                filter === MEMBER_STATUS.INACTIVE && MEMBER_STATUS.ACTIVE
              }`}
              onClick={() => setFilter(MEMBER_STATUS.INACTIVE)}
            >
              <FormattedMessage id="locked" />
            </a>
          </li>
        </ul>
      </div>

      <div className="col-lg-4 col-xxl-3">
        <BlueButton
          block
          size="large"
          type="primary"
          className="btn btn-primary mb-0 float-end commonBlueBtn"
          onClick={() => setIsOpen(true)}
        >
          <i className="bi bi-person-plus me-2"></i><FormattedMessage id="add.new.button" />
        </BlueButton>
      </div>
    </div>
  );
};

export default FilterableHeader;
